import { render, staticRenderFns } from "./AdministrativePermitsTableDetails.vue?vue&type=template&id=7ee2a302&scoped=true"
import script from "./AdministrativePermitsTableDetails.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsTableDetails.vue?vue&type=style&index=0&id=7ee2a302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee2a302",
  null
  
)

export default component.exports